import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

interface ButtonProps {
  children: ReactNode
  variant?: 'primary' | 'secondary'
  href?: string
  to?: string
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export default function Button({
  children,
  variant = 'primary',
  href,
  to,
  onClick,
  disabled = false,
  className = ''
}: ButtonProps) {
  const baseClasses = "inline-block px-6 py-2.5 rounded-full font-semibold text-[0.95rem] transition-all duration-200"

  const variantClasses = {
    primary: "bg-accent text-[#06301c] shadow-[0_14px_32px_-18px_rgba(20,154,62,0.8)] hover:bg-accent-dark hover:text-white hover:-translate-y-0.5",
    secondary: "bg-surface-muted text-ink hover:bg-gray-200"
  }

  const classes = `${baseClasses} ${variantClasses[variant]} ${disabled ? 'opacity-60 pointer-events-none' : ''} ${className}`

  // Link/anchor variants are only used for non-action CTAs (never disabled).
  if (to) {
    return <Link to={to} className={classes}>{children}</Link>
  }

  if (href) {
    return <a href={href} className={classes}>{children}</a>
  }

  return (
    <button onClick={onClick} disabled={disabled} className={classes}>
      {children}
    </button>
  )
}
